import { styled } from '@mui/material';
import { palette } from 'view/themes/palette';

const Arrow = ({ className, onClick }: { className?: string; onClick?: () => void }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick}
      style={{ cursor: onClick ? 'pointer' : 'default' }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.7071 4.29289C13.0976 4.68342 13.0976 5.31658 12.7071 5.70711L6.41421 12L12.7071 18.2929C13.0976 18.6834 13.0976 19.3166 12.7071 19.7071C12.3166 20.0976 11.6834 20.0976 11.2929 19.7071L4.29289 12.7071C3.90237 12.3166 3.90237 11.6834 4.29289 11.2929L11.2929 4.29289C11.6834 3.90237 12.3166 3.90237 12.7071 4.29289Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 12C4 11.4477 4.44772 11 5 11H19C19.5523 11 20 11.4477 20 12C20 12.5523 19.5523 13 19 13H5C4.44772 13 4 12.5523 4 12Z"
        fill="black"
      />
    </svg>
  );
};

const getRotation = (rotate?: string) => {
  switch (rotate) {
    case 'left':
      return '0deg';
    case 'right':
      return '180deg';
    case 'up':
      return '90deg';
    case 'down':
      return '-90deg';
    default:
      return '0deg';
  }
};

const ArrowIcon = styled(Arrow)(({
  rotate,
  color,
}: {
  rotate?: 'left' | 'right' | 'up' | 'down';
  color?: string;
}) => {
  return {
    transform: `rotate(${getRotation(rotate || 'left')})`,
    '& path': {
      fill: color || palette.primary.purple500,
    },
  };
});

export default ArrowIcon;
